<template>
  <div
    class="algolia-search-bar-input__size-sm flex grow"
    :class="!$isSol ? 'rounded-4xl !bg-blue-100' : ''"
  >
    <ScreenWidthProvider
      v-slot="{ isWider }"
      class="flex items-center grow "
    >
      <SearchIconSVG
        v-if="!$isSol"
        class="!w-5 !h-5 ml-4 text-secondary"
      />
      <input
        id="articles-search-header"
        ref="input"
        type="search"
        autocomplete="off"
        data-i18n="searchFieldPlaceholder|searchButtonText|searchStats"
        class="algolia-search-bar-input__size-sm__input pl-2 lg:!-ml-2 placeholder:text-secondary placeholder:!font-normal placeholder:!font-secondary"
        :placeholder="isWider('sm') ? $t('searchFieldPlaceholder') : $t('searchButtonText')"
        :value="value"
        @keydown="$emit('activate', $event)"
        @keyup.enter="$emit('goto', value)"
        @input="$emit('refine', $event.currentTarget.value)"
      />
    </ScreenWidthProvider>
    <div class="inline-block h-full algolia-search-bar-btn-wrapper">
      <button
        class="btn-medium-blue btn-bold text-center px-3"
        :class="$isSol ? 'btn-orange' : ''"
        type="submit"
        data-i18n="searchButtonText"
        @click="$emit('goto', value)"
      >
        {{ $t('searchButtonText') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import SearchIconSVG from '@packages/icons/search-icon.svg'

defineProps({
  value: {
    type: String,
    default: '',
  },
})

const emit = defineEmits([
  'refine',
  'goto',
  'activate',
  'mounted',
])

const inputRef = useTemplateRef('input')

defineExpose({ inputRef })

onMounted(() => {
  emit('mounted')
})
</script>

<style lang="scss">
.algolia-search-bar-input {
  &__size-sm {
    border: 1px solid rgba(0, 0, 0, 0.20);

    &__input {
      height: 3.25em;
      width: calc(100% - 2rem);

      .styled-placeholder-topNavBar::placeholder {
        color: theme('colors.blue.800') !important;
        font-family: 'Inter';
        font-size: 14px !important;
        font-weight: 500 !important;
        opacity: 1;
      }

      .autosuggest__results-container {
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        background-color: white;
        max-height: 500px;
        overflow-y: auto;
        border-radius: 0;
        width: 100%;
        position: absolute;
      }

      &.search-header .autosuggest__results-container {
        width: calc(100% - 2rem);
      }

      .ais-Stats {
        cursor: pointer;
      }
    }
  }
}
</style>